import * as React from 'react';
import {
    Form,
    FormControl,
    FormElement,
    FormHeader,
    FormHelperText,
    FormLabel,
    SubmitHandler,
    Textarea,
    useForm,
    z,
    zodResolver,
} from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { raiseToast } from '@fiverr-private/toast';
import { AppI18n, appTranslate as t } from '../../../utils/i18n';
import { RequestType } from '../types';
import { sendUpgradeRequest } from '../../../api/upgradeToAdvanced';

export const FORM_ID = 'upgrade-request-form';

interface TextAreaSectionProps {
    onSuccessfulRequest: () => void;
    requestType: RequestType;
}

export const TextAreaSection = ({ onSuccessfulRequest, requestType }: TextAreaSectionProps) => {
    const schema = z.object({
        note: z.string().optional(),
    });
    type SchemaType = z.infer<typeof schema>;

    const methods = useForm<SchemaType>({
        resolver: zodResolver(schema),
        mode: 'onChange',
    });

    const onSubmit: SubmitHandler<SchemaType> = async (data) => {
        try {
            await sendUpgradeRequest(data.note);
            onSuccessfulRequest();
        } catch (e) {
            raiseToast({ message: t('request_upgrade_modal.error'), location: 'top', type: 'error' });
        }
    };
    return (
        <Form id={FORM_ID} methods={methods} onSubmit={onSubmit}>
            <FormControl name="note">
                <FormHeader>
                    <FormLabel>
                        <AppI18n
                            k={'request_upgrade_modal.add_note'}
                            templates={{
                                optional: (text) => (
                                    <Text as="span" color="bodySecondary">
                                        {text}
                                    </Text>
                                ),
                            }}
                        />
                    </FormLabel>
                </FormHeader>
                <FormElement>
                    <Textarea
                        maxLength={270}
                        rows={5}
                        placeholder={t(`request_upgrade_modal.types.${requestType}.placeholder`) as string}
                    />
                </FormElement>
                <FormHelperText />
            </FormControl>
        </Form>
    );
};
